import React from 'react'
import PropTypes from 'prop-types'
import TabNavItem from './TabNavItem'
import TabNavNoLinkItem from './TabNavNoLinkItem'

import styled from '@emotion/styled'
import { cx } from 'emotion'
import { SPACING_MULTIPLIERS } from 'portal-modules/tenant-portal-layout/constants/layout-constants'

const StyledUl = styled('ul')`
  list-style-type: none;
  padding-left: 11px;

  @media only screen and (max-width: 500px) {
    margin: 0;
  }

  &.tabs--header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  :not(:first-child) {
    margin-top: 16px;
  }

  @media only screen and (min-width: 1574px) {
    padding: calc(${SPACING_MULTIPLIERS.TAB_NAV_TOP}rem * var(--spacing-scale)) 0 0 calc(${SPACING_MULTIPLIERS.TAB_NAV_LEFT}rem * var(--spacing-scale));
  }
  a {
    color: ${({ theme }) => theme.mode.tab_active_text_color};
  }
`

/**
 * A component for tabbed navigation.
 * It can be used in either `Page.Header` or `Page.Content`, but should have an appropriate
 * `type` prop for its placement to get the correct style.
 */
const TabNav = ({ children, className, type }) => (
  <StyledUl className={cx(`tabs--${type}`, className)}>{children}</StyledUl>
)

TabNav.propTypes = {
  /** Children should only be `TabNav.Item`s */
  children: PropTypes.any,
  className: PropTypes.string,
  /** Determines styling for the nav based on where it should live, `Page.Header` or `Page.Content`. */
  type: PropTypes.oneOf(['header', 'content']),
}

TabNav.defaultProps = {
  type: 'header',
}

TabNav.Item = TabNavItem
TabNav.NoLinkItem = TabNavNoLinkItem

export default TabNav